export default __webpack_public_path__ + "static/media/opening.19530fec.svg";